export default __webpack_public_path__ + "static/PES-mobile-1-4b95c0166fce86bd87fe197aa1080edb.jpg";